import { useContext } from "react";
import { Box } from "@mui/material";
import { HeadingText, ParagraphText, UBButton } from "../../../Libraries";
import { PoweredRupinIcon, RupinFavIcon, RupinNewLogo } from "../../../assets/icons/icon";
import { LanguageContext } from "../../../context/LanguageContext";
import { formatNum } from "../../../oscar-pos-core/constants";
import styles from "./styles.module.css";

const UCashTransactionSuccess = ({
  subtitle = "",
  recipientName = "",
  recipientSuffix = "",
  tid = "",
  amount = 0,
  remainingAmount = 0,
  processingTime = "",
  onViewReceipt,
  onClose,
  onDownload,
  isDownloadLoading = false,
  onBack,
  primaryBtnTitle,
  onPrimaryAction,
  isPrimaryLoading = false,
  secondaryBtnTitle,
}) => {
  const [I18n] = useContext(LanguageContext);

  const recipientLabel = recipientName
    ? `${recipientName}${recipientSuffix ? ` - ${recipientSuffix}` : ""}`
    : "";

  return (
    <Box className={styles.wrapper}>
      <Box className={styles.contentShell}>
        <Box className={styles.innerCard}>

          <Box className={styles.body}>
            
            <Box className={styles.topContent}>
            <RupinNewLogo width={77} height={20} />

            {recipientLabel ? (
              // Urdu label goes first (on the right), so the line must be RTL; the Latin name and
              // "- 1234" stay LTR inside their own span.
              <ParagraphText
                className={`fontSize14 ${styles.subtitle}`}
                dir={/[\u0600-\u06FF]/.test(I18n.money_sent_to) ? "rtl" : "ltr"}
              >
                {I18n.money_sent_to}{" "}
                <span className={styles.recipientBold} dir="ltr">{recipientLabel}</span>
              </ParagraphText>
            ) : subtitle ? (
              <Box className={`fontSize14 ${styles.subtitle} ${styles.subtitleFlex}`}>
                {subtitle}
              </Box>
            ) : null}

            {tid ? (
              <ParagraphText className={`fontSize14 newFontColor ${styles.tid}`}>
                {I18n.tid}: {tid}
              </ParagraphText>
            ) : null}
            </Box>

            <Box className={styles.amountContainer}>
            <HeadingText tag="h1" className={styles.amount}>
              Rs. {formatNum(amount)}
            </HeadingText>

            {remainingAmount > 0 ? (
              <ParagraphText
                className={`fontSize20 newFontColor fontWeight400 ${styles.remainingPayment}`}
              >
                {I18n.remaining_payment}: <span className="fontWeight600" >Rs. {formatNum(remainingAmount)}</span>
              </ParagraphText>
            ) : null}

           
            </Box>

            <Box className={styles.logoWrap}>
              <RupinFavIcon width={50} height={50} />
            
            {onViewReceipt ? (
              <ParagraphText
                className={`fontSize14 fontWeight500 ${styles.viewReceiptLink}`}
                onClick={onViewReceipt}
              >
                {I18n.view_receipt}
              </ParagraphText>
            ) : null}
            </Box>


            <Box className={styles.poweredBy}>
              <PoweredRupinIcon />
            </Box>
          </Box>

          <Box className={styles.bottomBar}>
            {onClose ? (
              <UBButton
                id="ucash_success_close_btn"
                title={secondaryBtnTitle || I18n.close}
                className={`buttonTeritary textUppercase ${styles.closeBtn}`}
                onClick={onClose}
              />
            ) : null}
            <UBButton
              id={primaryBtnTitle ? "ucash_success_primary_btn" : "ucash_success_download_btn"}
              title={
                primaryBtnTitle || I18n.download_recipt
              }
              className={`ubPrimaryButton textUppercase ${styles.downloadBtn}`}
              loading={primaryBtnTitle ? isPrimaryLoading : isDownloadLoading}
              disabled={primaryBtnTitle ? isPrimaryLoading : isDownloadLoading}
              onClick={onPrimaryAction || onDownload}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UCashTransactionSuccess;
